import React, { useState, useEffect } from "react";
import "./project_list.css";

const ProjectList = () => {
  const [projects, setProjects] = useState({});
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubCategory, setSelectedSubCategory] = useState();

  useEffect(() => {
  fetch("/projects.json")
    .then((res) => res.json())
    .then((data) => {
      setProjects(data);

      // Set default category and subcategory
      const defaultCategory = "Software";
      const defaultSubCategory = "AI/ML";

      if (data[defaultCategory]) {
        setSelectedCategory(defaultCategory);
        if (data[defaultCategory][defaultSubCategory]) {
          setSelectedSubCategory(defaultSubCategory);
        } else {
          // fallback to first subcategory if AI/ML doesn't exist
          const firstSub = Object.keys(data[defaultCategory])[0];
          setSelectedSubCategory(firstSub || null);
        }
      }
    })
    .catch((err) => console.error("Failed to load projects.json:", err));
}, []);


  const handleCategoryClick = (cat) => {
    setSelectedCategory(cat);
    setSelectedSubCategory(null);
  };

  const handleSubCategoryClick = (subCat) => {
    setSelectedSubCategory(subCat);
  };

   const bubbles = Array.from({ length: 8 }).map((_, i) => (
    <div key={i} className="bubble" />
  ));

  const subCategories =
    selectedCategory && projects[selectedCategory]
      ? Object.keys(projects[selectedCategory])
      : [];

  const projectsToShow =
    selectedSubCategory && projects[selectedCategory]
      ? projects[selectedCategory][selectedSubCategory]
      : [];

  return (
    <div className="pl-container">

      {[...Array(15)].map((_, i) => (
        <div key={i} className="bubble"></div>
      ))}
      
      <h1 className="pl-title">Project List</h1>

      {/* Level 1 Categories */}
      <div className="pl-category-buttons">
        {Object.keys(projects).map((cat) => (
          <button
            key={cat}
            className={`pl-category-btn ${
              selectedCategory === cat ? "pl-active-category" : ""
            }`}
            onClick={() => handleCategoryClick(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Level 2 Subcategories */}
      {selectedCategory && subCategories.length > 0 && (
        <div className="pl-subcategory-buttons">
          {subCategories.map((sub) => (
            <button
              key={sub}
              className={`pl-subcategory-btn ${
                selectedSubCategory === sub ? "pl-active-subcategory" : ""
              }`}
              onClick={() => handleSubCategoryClick(sub)}
            >
              {sub}
            </button>
          ))}
        </div>
      )}

      {/* Projects or Message */}
      {selectedCategory === null ? (
        <p className="pl-select-message">Please select a category to view projects.</p>
      ) : selectedSubCategory === null ? (
        <p className="pl-select-message">Please select a subcategory to view projects.</p>
      ) : projectsToShow.length > 0 ? (
        <div className="pl-project-cards">
          {projectsToShow.map((project) => (
            <div key={project.id} className="pl-project-card">
              <h4 className="pl-project-name">
                {project.name || project.namee || "Unnamed Project"}
              </h4>
              <h3 className="pl-project-title">
                {project.title || "No Title"}
              </h3>
            </div>
          ))}
        </div>
      ) : (
        <p className="pl-select-message">No projects found for this subcategory.</p>
      )}
    </div>
  );
};

export default ProjectList;
